import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { AuthContext, Loader, ViewContext } from "@/components/lib";
import Styles from "@/css/mainStyles";
import axios from "axios";

export default function DeleteAccountModal({ id, setOpen }) {
  const viewContext = useContext<any>(ViewContext);
  const authContext = useContext<any>(AuthContext);
  const { handleSubmit } = useForm();

  const [loading, setLoading] = useState(false);

  const deleteAccountSubmit = async () => {
    const url = `/api/player/${id}`;

    try {
      setLoading(true);
      await axios({
        method: "delete",
        url
      });
      viewContext.notification.show("Account deleted", "success");
      authContext.signout();
    } catch (error) {
      console.error(error);
      viewContext.notification.show(error.message, "error");
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(deleteAccountSubmit)}>
      <h2 className="text-lg md:text-2xl font-bold mb-2">Delete Account</h2>
      <h3 className="text-sm md:text-2xl mb-4">
        Are you sure you want to permanently delete your account?
      </h3>
      <p className="text-sm md:text-lg text-gray-600 mb-4">
        Deleting your account will permanently erase all your data after a
        30-day inactivity period. During this time, you can log back in to
        cancel the deletion. After 30 days, this action will be irreversible.
      </p>

      <div className="flex justify-between mt-4 gap-4">
        <button onClick={() => setOpen(false)} className={Styles.cancelButton}>
          Cancel
        </button>
        <button className={Styles.submitButton}>
          Confirm {loading && <Loader />}
        </button>
      </div>
    </form>
  );
}
